
import mixins from 'vue-typed-mixins'
import ScreenMixin from "@/mixins/ScreenMixin";
import { ApiService } from '@/services/ApiService';
import UnAuthMenuBar from "@/components/UnAuthMenuBar.vue";
import contact from "@/config/contact.json";

export default mixins(ScreenMixin).extend({
    name: "ContactUs",
    components:{
      UnAuthMenuBar
    },
    data: function () {
        return {
            name: "",
            email: "",
            message: "",
            isEmptyParameterPresent: false,
            isSent: false,
            isNotSent: false,
            contact: contact
        };
    },
    methods: {
        handleSubmit: async function (): Promise<any> {
            //checking for blank fields
            if (this.name == "" || this.email == "" || this.message == "") {
                //manage warning
                this.isEmptyParameterPresent = true;
                this.isNotSent = false;
                this.isSent = false;
                return;
            }
            else {
                try{
                    await ApiService.Instance.sendContactForm(this.name, this.email, this.message);
                    //display successful message
                    this.isEmptyParameterPresent = false;
                    this.isNotSent = false;
                    this.isSent = true;
                } catch(e){
                    //display error message
                    this.isNotSent = true;
                }
            }
        }
    }
})
